// Meta Pixel ID
const PIXEL_ID = '1225835136409461'

// Extend window type for fbq
declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: any
    _fbqInitialized?: boolean
  }
}

/** Inject the Meta Pixel script and fire the initial PageView */
export function initMetaPixel(): void {
  if (typeof window === 'undefined') return

  // Avoid firing PageView more than once per session
  if (window._fbqInitialized) return
  window._fbqInitialized = true

  // Inject the fbevents.js script only if fbq stub doesn't exist yet
  if (!window.fbq) {
    ;(function (
      f: any,
      b: Document,
      e: string,
      v: string,
      n?: any,
      t?: HTMLScriptElement,
      s?: Element,
    ) {
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      }
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []
      t = b.createElement(e) as HTMLScriptElement
      t.async = true
      t.src = v
      s = b.getElementsByTagName(e)[0]
      // s may be undefined if no <script> tags exist yet — fall back to <head>
      if (s?.parentNode) {
        s.parentNode.insertBefore(t, s)
      } else {
        b.head.appendChild(t)
      }
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    )
  }

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
}

/** Fire AddToCart event */
export function trackAddToCart(params?: {
  value?: number
  currency?: string
  contentName?: string
}): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', 'AddToCart', {
    value: params?.value ?? 6.39,
    currency: params?.currency ?? 'USD',
    content_name: params?.contentName ?? 'Feline Harmony Blueprint',
    content_type: 'product',
  })
}
